import { formatNumber } from "./format-number";

export function getLargeNumberString(input: number) {
	if (input === 0) return "0";
	if (input >= 1_000_000_000) return `${formatNumber(input / 1_000_000_000, "integer")}B`;
	if (input >= 1_000_000) return `${formatNumber(input / 1_000_000, "integer")}M`;
	if (input >= 1_000) return `${formatNumber(input / 1_000, "integer")}K`;
	return formatNumber(input, "integer");
}
